import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  showMum: false,
  hintMsg: '',
  user: {},
  isPost: false,
  pop_calories: 0,
  group: []
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})
